<template>
  <div :class="{ 'tw:relative tw:min-h-12': active }">
    <slot />

    <template v-if="active">
      <div class="tw:absolute tw:inset-0 tw:flex tw:justify-center tw:items-center tw:bg-white/70">
        <loader-circle class="tw:animate-spin tw:size-12 tw:text-blue-500"/>
      </div>
    </template>
  </div>
</template>

<script setup>
import { LoaderCircle } from '@lucide/vue';

defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
</script>
